export default "__VITE_ASSET__BsFv3Ycv__"